import { DraftEntityInstance } from "draft-convert";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Z } from "@ui/styles/zIndex";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";

interface UrlInputProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
	entity?: DraftEntityInstance;
	onChange: (value: string) => void;
	onBlur?: () => void;
}
export const UrlInput: React.FC<UrlInputProps> = ({ entity, onChange, onBlur, ...htmlProps }) => {
	const [url, setUrl] = useState(entity ? entity.getData().url : "");

	useEffect(() => setUrl(entity ? entity.getData().url : ""), [entity]);

	const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
		if (e.key === "Enter") {
			e.preventDefault();
			onBlur?.();
		}
	};

	return (
		<Container {...htmlProps}>
			<input
				autoFocus
				onKeyDown={onKeyDown}
				placeholder={"url..."}
				value={url}
				onChange={(e) => {
					setUrl(e.target.value);
					onChange(e.target.value);
				}}
				onBlur={() => onBlur?.()}
			/>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 10px 0;
	display: flex;
	align-items: center;

	input {
		border: none;
		outline: none;
		padding: 10px;
		width: 100%;
	}

	&::after {
		content: "";
		position: absolute;
		background-color: ${({ theme }) => theme.colors.backgroundPrimary};
		border-bottom-right-radius: 4px;
		border-right: 1px solid ${({ theme }) => theme.colors.lightergray};
		border-bottom: 1px solid ${({ theme }) => theme.colors.lightergray};
		z-index: ${Z.under};
		width: 14px;
		height: 14px;
		left: 50%;
		bottom: -1px;
		transform: translate(-50%, 50%) rotate(45deg);
	}
`;
